module.exports = __webpack_public_path__ + "static/img/yk8300.569be61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk8300.png
// module id = i8Dg
// module chunks = 1